//import images from 'assets/images/images'
import images from 'assets/images/images'
import IncDecrement from 'components/IncDecrement'
import SimpleAccordion from 'components/accordion/SimpleAccordion'
import Input from 'components/form-elements/Input'
import Button from 'components/form-elements/buttons/Button'
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Radio from 'components/form-elements/radio/Radio'
import Textarea from 'components/form-elements/textArea/Textarea'
import { useRequest } from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import React, { useEffect, useState } from 'react'
import { GrClose } from 'react-icons/gr'
import { FormattedNumber, IntlProvider } from 'react-intl'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import auth from 'utils/Auth'
import { dataLayerPush } from 'utils/Datalayer'

const AddBasketDrawerStageOne = ({setProductCount, productCount, productData, setIsOpenDrawer, setProductStage, isInPayment = false, setSingleDrawerProduct, componentName="list"}) => {
  const dispatch = useDispatch();
  const [request,loading] = useRequest();
  const [product, setProduct] = useState('')
  const { t } = useTranslate()
  useEffect(() => {
    return () => {
      setSingleDrawerProduct({ id: null, item: null })
      setProduct('')
    }
  },[])

  useEffect(() => {
    if(productData?.productCountStatic){
      setProductCount(1)
    }
  },[productData?.productCountStatic])


    
  const handleOnChange = (e, attValue, attribute, type) => {
    if (type == 'checkbox') {
      setProduct(prev => ({...prev,attributes:prev.attributes.map(attr => {
        if (attr.id == attribute.id) {
          return {...attr,values:attr.values.map(val => {
            if (val.id == attValue.id) {
              return {...val,isPreSelected:e.target.checked}
            } else {
              return {...val}
            }
          })}
        }else {
          return attr
        }
      })}))
    } else if (type == 'dropdown') {
      setProduct(prev => ({...prev,attributes:prev.attributes.map(attr => {
        if (attr.id == attribute.id) {
          return {...attr,values:attr.values.map(val => {
            if (val.id == attValue.id) {
              return {...val,isPreSelected:true}
            } else {
              return {...val,isPreSelected:false}
            }
          })}
        }else {
          return {...attr}
        }
      })}))
    } else if (type == 'radio') {
      setProduct(prev => ({...prev,attributes:prev.attributes.map(attr => {
        if (attr.id == attribute.id) {
          return {...attr,values:attr.values.map(val => {
            if (val.id == attValue.id) {
              return {...val,isPreSelected:e.target.checked}
            } else {
              return {...val, isPreSelected:false}
            }
          })}
        }else {
          return attr
        }
      })}))
    }
  }
   
     const headerOptions = {
      RestaurantId : auth?.getUserChoises()?.restaurantId,
      DeliveryType : auth?.getUserChoises()?.deliveryType,
      NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
      RegionId : auth?.getUserChoises()?.regionId,
    }
    
     useEffect(() => {
      if (productData?.createdPlate) {
        setProduct({
          ...productData?.createdPlate
        })
       } else if (productData?.id && !productData?.item) {
        request(`/Catalog/Products/${productData?.id}`, {
          method: 'GET',
          headers: headerOptions
        }).then((res) => {
          if(res.data){
            setProduct(res?.data?.result)
          }
        })
       } else if (productData?.id && productData.item && !productData?.item?.isCreateYourOwnPlate){
        request(`/Catalog/Products/${productData?.id}`, {
          method: 'GET',
          headers: headerOptions
        }).then((res) => {
          if(res.data){
            setProduct({
              ...res?.data?.result,
              attributes:res?.data?.result?.attributes?.map(attr => {
                const currentAttr = productData?.item?.attributes?.filter(a => a.productAttributeId == attr.id)
                if (currentAttr?.length == 1) {
                  if (attr?.values?.length>0) {
                    return {
                      ...attr,
                      values:attr?.values?.map(val => {
                        if (val.id == currentAttr[0]?.value) {
                          return {...val,isPreSelected : true}
                        }else {
                          return {...val}
                        }
                      })
                    }
                  } else {
                    return {
                      ...attr,
                      defaultValue:currentAttr[0]?.value 
                    }
                  }
                } else if (currentAttr?.length > 1) {
                  const mapped = currentAttr?.map(c => c.value)
                  return {
                    ...attr,
                    values:attr?.values?.map(val => {
                      if (mapped.includes(val.id.toString())) {
                        return {
                         ...val, isPreSelected : true
                        }
                      }else {
                        return {...val}
                      }
                    })
                  }
                } else {
                  return {...attr}
                }
              }) 
            })
          }
          if (res?.response?.status === 500) {
            if (isInPayment) {
              setIsOpenDrawer(false)
              setProductStage(1)
            } else {
              setProductStage(2)
            }
          }
        })
       } else if (productData.id == null) {
        setProduct('')
       }
    },[productData?.id])
    const getPostArray = () => {
      const mappedArray = product?.attributes?.filter(a => a.controlType == 3)?.length > 0 ? product?.attributes?.filter(a => a.controlType == 3)?.map(attribute => {
        return [
          ...attribute.values.map(element => {
            return {
              "productAttributeId": attribute.id,
              "value":element?.isPreSelected ? element?.id?.toString() : null,
              "price":element?.isPreSelected ? element?.price : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": element?.name,
							"attributeName": attribute?.name,
            }
          })
        ]
      }) : []
      const mappedArrayWithoutType3 = product?.attributes?.filter(a => a.controlType != 3)?.map(attribute => {
        switch (attribute.controlType) {
          case 1:
            return {
              "productAttributeId": attribute.id,
              "value":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.id?.toString() : null,
              "price":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.price : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.name : null,
							"attributeName": attribute?.name,
            }
          case 2:
            return {
              "productAttributeId": attribute.id,
              "value":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.id?.toString() : null,
              "price":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.price : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.name : null,
							"attributeName": attribute?.name,
            }
          case 4 :
            return {
              "productAttributeId": attribute.id,
              "value":attribute?.defaultValue ? attribute?.defaultValue : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": attribute?.defaultValue ? attribute?.defaultValue : null,
							"attributeName": attribute?.name,
            }
          case  5:
            return {
              "productAttributeId": attribute.id,
              "value":attribute?.defaultValue ? attribute?.defaultValue : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": attribute?.defaultValue ? attribute?.defaultValue : null,
							"attributeName": attribute?.name,
            }
          case 6:
            return {
              "productAttributeId": attribute.id,
              "value":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.id?.toString() : null,
              "price":attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.price : null,
              "parentProductAttributeId": attribute.parentProductAttributeId,
              "productName": attribute?.values?.find(att => att.isPreSelected) ? attribute?.values?.find(att => att.isPreSelected)?.name : null,
							"attributeName": attribute?.name,
            }
          default:
            return { value: null};
        }
      })
      const postArray = mappedArray[0]?.length > 0 ? [
        // eslint-disable-next-line no-unsafe-optional-chaining
        ...mappedArrayWithoutType3,
        ...mappedArray[0]
      ]?.filter(a => a.value != null)
      : mappedArrayWithoutType3?.length > 0 ? [
        ...mappedArrayWithoutType3
      ]?.filter(a => a.value != null) : []
      return postArray
    }
    const addBasket = () => {
      if(!auth.isHaveToken()){
          toast.error(t('cannotAddtoCart'))
      }
      
      if(productData.item){
      request(`/ShoppingCart/RemoveItem?id=${productData.item.id}`, {
        method: 'POST',
        headers: headerOptions
      }).then((res) => {
      if(res.data){
        // eslint-disable-next-line no-unsafe-optional-chaining
       
        const newData = {
          "productId": productData?.id,
          "quantity": productCount,
          "attributes": getPostArray()
      }
      const productAttributes = product?.attributes
      const breadSelection = productAttributes?.find((a) => a?.name?.includes("Ekmek"))?.values?.find((a) => a?.isPreSelected)?.name
      const saladSelection = productAttributes?.find((a) => a?.name?.includes("Salata"))?.values?.find((a) => a?.isPreSelected)?.name
      const promotionSelection = productAttributes?.find((a) => a?.name?.includes("Promosyon"))?.values?.find((a) => a?.isPreSelected)?.name
      request('/ShoppingCart/UpdateCart', {
          method: 'POST',
          data: newData,
          headers: headerOptions
        }).then((res) => {
          if(res.data){
              dataLayerPush({ ecommerce: null });
              dataLayerPush({
                event:"add_to_cart",
                ecommerce: {
                  item_list_name: "Listeleme Sayfası",
                  currency: "TRY",
                  component: componentName,
                  value: productCount *
                  (product?.discountedPrice +
                    getPostArray()
                      ?.filter((a) => a?.price)
                      ?.reduce((a, b) => a + b?.price, 0)),
                  bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
                  salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
                  promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
                  items: getPostArray()?.length > 0 ? [{
                  item_id: product.id,
                  item_name: product.name,
                  affilication: "Tavuk Dünyası",
                  discount: product.discountAmount,
                  item_variant:'Ana Ürün',
                  index: 0,
                  item_brand: "Tavuk Dünyası",
                  item_category: product.categories?.[0]?.value,
                  item_category2: product.categories?.[1]?.value ? product.categories?.[1]?.value : "",
                  item_category3: product.categories?.[2]?.value ? product.categories?.[2]?.value: "",
                  item_list_name: "Listeleme Sayfası",
                  price: product.price,
                  quantity: productCount
                // eslint-disable-next-line no-unsafe-optional-chaining
                }, ...getPostArray()?.map((a, i) => ({
                  item_id: a.productAttributeId,
                  item_name: a.productName,
                  item_category: a.attributeName,
                  affilication: "Tavuk Dünyası",
                  discount: 0,
                  item_variant:'Ek Ürün',
                  index: i + 1,
                  item_brand: "Tavuk Dünyası",
                  price: a.price || 0,
                  quantity: 1
                }))] : [{
                  item_id: product.id,
                  item_name: product.name,
                  affilication: "Tavuk Dünyası",
                  discount: product.discountAmount,
                  item_variant:'Ana Ürün',
                  index: 0,
                  item_brand: "Tavuk Dünyası",
                  item_category: product.categories?.[0]?.value,
                  item_category2: product.categories?.[1]?.value ? product.categories?.[1]?.value : "",
                  item_category3: product.categories?.[2]?.value ? product.categories?.[2]?.value: "",
                  item_list_name: "Listeleme Sayfası",
                  price: product.price,
                  quantity: productCount
                }]
                }
              })
              toast.success(t('productAddedToCart'))
              if (isInPayment) {
                setIsOpenDrawer(false)
                setProductStage(1)
                dispatch(getAllBasketFunc(res?.data?.result))
              } else {
                dispatch(getAllBasketFunc(res?.data?.result))
                setProductStage(2)
              }
          }
        })
      }
      })
      }else{
        const newData = {
          "productId": productData?.id,
          "quantity": productCount,
          "attributes": getPostArray()
      }
      const productAttributes = product?.attributes
      const breadSelection = productAttributes?.find((a) => a?.name?.includes("Ekmek"))?.values?.find((a) => a?.isPreSelected)?.name
      const saladSelection = productAttributes?.find((a) => a?.name?.includes("Salata"))?.values?.find((a) => a?.isPreSelected)?.name
      const promotionSelection = productAttributes?.find((a) => a?.name?.includes("Promosyon"))?.values?.find((a) => a?.isPreSelected)?.name
      request('/ShoppingCart/UpdateCart', {
          method: 'POST',
          data: newData,
          headers: headerOptions
        }).then((res) => {
          if(res.data){
              dataLayerPush({ ecommerce: null });
              dataLayerPush({
                event:"add_to_cart",
                ecommerce: {
                  item_list_name: "Listeleme Sayfası",
                  currency: "TRY",
                  value:productCount *
                  (product?.discountedPrice +
                    getPostArray()
                      ?.filter((a) => a?.price)
                      ?.reduce((a, b) => a + b?.price, 0)),
                  bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
                  salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
                  promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
                  component: componentName,
                  items: getPostArray()?.length > 0 ? [{
                    item_id: product.id,
                    item_name: product.name,
                    affilication: "Tavuk Dünyası",
                    discount: product.discountAmount,
                    item_variant:'Ana Ürün',
                    index: 0,
                    item_brand: "Tavuk Dünyası",
                    item_category: product.categories?.[0]?.value,
                    item_category2: product.categories?.[1]?.value ? product.categories?.[1]?.value : "",
                    item_category3: product.categories?.[2]?.value ? product.categories?.[2]?.value: "",
                    item_list_name: "Listeleme Sayfası",
                    price: product.price,
                    quantity: productCount
                  // eslint-disable-next-line no-unsafe-optional-chaining
                  }, ...getPostArray()?.map((a, i) => ({
                    item_id: a.productAttributeId,
                    item_name: a.productName,
                    item_category: a.attributeName,
                    affilication: "Tavuk Dünyası",
                    discount: 0,
                    item_variant:'Ek Ürün',
                    index: i + 1,
                    item_brand: "Tavuk Dünyası",
                    price: a.price || 0,
                    quantity: 1
                  }))] : [{
                    item_id: product.id,
                    item_name: product.name,
                    affilication: "Tavuk Dünyası",
                    discount: product.discountAmount,
                    item_variant:'Ana Ürün',
                    index: 0,
                    item_brand: "Tavuk Dünyası",
                    item_category: product.categories?.[0]?.value,
                    item_category2: product.categories?.[1]?.value ? product.categories?.[1]?.value : "",
                    item_category3: product.categories?.[2]?.value ? product.categories?.[2]?.value: "",
                    item_list_name: "Listeleme Sayfası",
                    price: product.price,
                    quantity: productCount
                  }]
                }
              })
              toast.success(t('productAddedToCart'))
              if (!isInPayment) {
                dispatch(getAllBasketFunc(res?.data?.result))
                setProductStage(2)
              }
              if (isInPayment) {
                setIsOpenDrawer(false)
                setProductStage(1)
                dispatch(getAllBasketFunc(res?.data?.result))
              }
          }
        })
      }
      
    }

    const textChoice = (e,attribute) => {
      let text =  e.target.value
      setProduct(prev => ({...prev,attributes:prev.attributes.map(attr => {
        if (attr.id == attribute.id) {
          return {...attr,defaultValue:text}
        }else {
          return attr
        }
      })}))
    }
    const otherChoice = (e, attribute) => {
      handleOnChange(e, JSON.parse(e.target.value), attribute, 'dropdown')
    }
 
    return (
    <div className='addBasketDrawerStageOne additionalProduct mt-0'>
        {
          loading || !product ? <div className="skeleton skeleton-home-slider"/>
          :
          <>
          <div onClick={() => {
            setIsOpenDrawer(false)
            if (isInPayment) {
              setProductStage(1)
            }
            }} className='addBasketDrawerStageOne-close'>
            <GrClose size={30}/>
        </div>
       {product?.appliedCampaigns?.[0]?.value && <div className='addBasketDrawerStageOne-badge'>
            <img src={images.stars} alt="" />
            <div>{product?.appliedCampaigns?.[0]?.value}</div>
        </div>}
          <div className='additionalProduct-text'>
            <div className='additionalProduct-text-title'>{product?.name}</div>
            <div className='additionalProduct-text-price'>
              {(product?.discountedPrice + getPostArray()?.filter(a => a?.price)?.reduce((a,b) => a + b?.price ,0))?.toFixed(2)}
              <span className=''> TL</span>
            </div>
            {product?.discountedPrice != product?.price && (
              <div className='additionalProduct-text-oldprice d-flex align-items-start'>
							{
								<IntlProvider locale={'tr'} defaultLocale='en'>
									<FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={product?.price} style={'decimal'} />
								</IntlProvider>
							}{' '}
							TL
						</div>
            )}
          </div>
          <div className="additionalProduct-list">
            {
                // product?.attributes?.map((attribute,index) => ( sadece attributestan gelecek...
                product?.attributes?.map((attribute, index) => {
                  return attribute?.controlType == 2 ? (
                    <SimpleAccordion
                      border
                      key={index}
                      header={
                        <div className={`d-flex flex-column ${attribute?.values?.find((att) => att.isPreSelected)?.name ? "gap-3" : "gap-0"}`}>
                          <div className='body-m'>{attribute?.name}{attribute?.isRequired ? '*':''}</div>
                          <div className='body-s'>
                            {/* bu kısmın revize edilmesi lazım */}
                            {attribute?.values?.find((att) => att.isPreSelected)?.name}
                          </div>
                        </div>
                      }
                      content={
                        <div className='d-flex flex-column'>
                          {attribute?.values.map((att, i) => (
                            <div key={i} className='radio-list-item'>
                              <Radio
                                onChange={(e) => handleOnChange(e, att, attribute, 'radio')}
                                className='radio-orange'
                                value={JSON.stringify(att)}
                                id={`radio${attribute.id}${att.id}`}
                                name={`radio${index}`}
                                checked={att.isPreSelected}
                              />
                              <span className='flex-1 header-s'>{att?.name}</span>
                              <span className='header-m text-orange'>{att?.price == 0 ? t('free') : `${att?.price} TL`}</span>
                            </div>
                          ))}
                          
                        </div>
                      }
                    />
                  ) : attribute?.controlType == 3 ? (
                    <SimpleAccordion
                    border
                      header={
                        <div className={`d-flex flex-column ${attribute?.values?.filter((att) => att.isPreSelected)?.map(att => att.name)?.join(',') ? "gap-3" : "gap-0"} `}>
                          <div className='body-m'>{attribute?.name}{attribute?.isRequired ? '*':''}</div>
                          <div className='body-s'>{attribute?.values?.filter((att) => att.isPreSelected)?.map(att => att.name)?.join(',')}</div>
                        </div>
                      }
                      content={
                        <div className='d-flex flex-column'>
                          {attribute?.values.map((att, i) => (
                            <div className='additionalProduct-addproduct-check' key={i}>
                              <Checkbox
                                onChange={(e) => handleOnChange(e,att, attribute, 'checkbox')}
                                className={'checkbox checkbox-orange'}
                                textLabel={''}
                                checked={att.isPreSelected}
                              />
                              <div className='header-s flex-1'>{att?.name}</div>
                              <div className='header-m text-orange'>{att?.price == 0 ? t('free') : `${att?.price} TL`}</div>
                            </div>
                          ))}
                        </div>
                      }
                    />
                  ) : attribute?.controlType == 4 ? (
                    <Input maxLength={attribute?.validationMaxLength && attribute?.validationMaxLength} containerClassName={''} className={''} placeholder={attribute?.name} type={'text'} value={attribute?.defaultValue} textLabel={''} name='' onChange={(e) => textChoice(e,attribute)} />
                  ) : attribute?.controlType == 5 ? (
                    <div className='d-flex flex-column gap-1 mt-3'>
                      {/* <div className='body-m'>Ürün Notu</div> */}
                      {attribute?.description && <div className='body-m'>{attribute?.description}{attribute?.isRequired ? '*':''}</div>}
                      <Textarea maxLength={attribute?.validationMaxLength && attribute?.validationMaxLength} id='textareaChange' value={attribute?.defaultValue} onChange={(e) => textChoice(e,attribute)} cols='30' rows='10' />
                    </div>
                  ) : attribute?.controlType == 1 ? (
                    <div className='form-control mt-4'>
                      <div className='form-control-label body-m'>{attribute?.name} {attribute?.isRequired ? '*':''}</div>
                      <select className='body-m' onChange={(e) => otherChoice(e, attribute)} name='' id='selectAdd'>
                      <option value="" hidden selected>{t('choosePlaceholder')}</option>
                        {attribute?.values.map((att, i) => (
                          // <div className='additionalProduct-addproduct-check' key={i}>
                          <option key={i} selected={att.isPreSelected} value={JSON.stringify(att)} className={'checkbox checkbox-orange'}>
                            {att?.name}
                          </option>
                          // </div>
                        ))}
                      </select>
                    </div>
                  ) : (
                    ''
                  )
                })
              }
        </div>
        <div className="addBasketDrawerStageOne-mobile-bottom">
           <select value={productCount} onChange={(e) => setProductCount(e.target.value)} >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
          </select> 
          <Button onClick={addBasket} className={"claretredRoundedBtn mobile"} icon={""} text={t('addToCardWithCount',{productCount: productCount, price:(productCount*(product?.discountedPrice + getPostArray()?.filter(a => a?.price)?.reduce((a,b) => a + b?.price ,0)))?.toFixed(2)})}/>
        </div>
        <div className='addBasketDrawerStageOne-select pb-2'>
          <IncDecrement setProductCount={setProductCount} productCount={productCount}/>
        </div>
        <Button onClick={addBasket} className={"claretredRoundedBtn"} icon={""} text={t('addToCardWithCount',{productCount: productCount, price:(productCount*(product?.discountedPrice + getPostArray()?.filter(a => a?.price)?.reduce((a,b) => a + b?.price ,0)))?.toFixed(2)})}/>
          </>
        }
        
    </div>
  )
}

export default AddBasketDrawerStageOne